export default class HttpStatusError extends Error {
  constructor(status, ...params) {
    super(...params)
    this.status = status
    this.name = 'Http status error'
    this.message = 'Query failed with http error ' + status
  }
}